import React from "react";
import Button from "@mui/material/Button";
import ContentTitles from "@/ui/content-titles/content-titles";
import {ParallaxContent} from "@/content/parallax-heros/parallax-heros.content";
import HeroContent from "@/ui/hero-content/hero-content";


type ParallaxContentProps = {
    content: ParallaxContent;
    align?: 'left' | 'center' | 'right';
    tint?: string;
};

const ParallaxHero: React.FC<ParallaxContentProps> = ({
                                                     content:{
                                                         title,
                                                         subTitle,
                                                         overline,
                                                         imageUrl,
                                                         buttonCTA,
                                                         buttonLink,
                                                     },
                                                          align = 'center',
    tint
                                                   }) => {
    const buttonStyles = {
        textTransform: "capitalize",
        color: "#000",
        borderRadius: "10px",
        textAlign: "center",
        backgroundColor: "#FFF",
        border: "none",
        width: "max-content",
    };

    return (
        <HeroContent
            backgroundPosition='center bottom relative'
            src={imageUrl}
        >
            {tint && (
                <div
                    className="absolute inset-0 bg-opacity-50"
                    style={{ backgroundColor: tint }}
                />
            )}
            <div className="parallax-container">

                {align === 'right' && <div className="hidden lg:block"></div>}
                <div>
                    <ContentTitles
                        title={title}
                        subTitle={subTitle}
                        overline={overline}
                        titleComponent='h1'
                        style='white'
                    />
                    <div className="parallax-content">
                        <Button
                            variant='outlined'
                            className='slide-up'
                            sx={buttonStyles}
                            href={buttonLink}
                        >
                            {buttonCTA}
                        </Button>
                    </div>
                </div>
                {align === 'left' && <div className="hidden lg:block"></div>}
            </div>
        </HeroContent>

    );
};

export default ParallaxHero;
